import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { PropertyFileModel } from 'app/models/property-file.model';
import { PropertyFilesService } from 'app/services/property-files.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class PropertyFileResolver implements Resolve<PropertyFileModel> {
  constructor(private service:PropertyFilesService){

  }

  resolve(route: ActivatedRouteSnapshot): Observable<PropertyFileModel> {
    return this.service.GetPropertyFile(route.params.file_id);
  }
}
